export const NEW_PRODUCT_BRIEFS_FIELDS = {
    storeValue: "newProductBrief",
    formFields: ["client", "product", "objective", "markets"],
    mandatoryFormFields: ["client", "product"],
    fieldsToQuery: ["countries", "parties"],
    createMutation: "productBriefsModule/productBriefCreate", 
    storeMutation: "productBriefsModule/setSingleProductBriefValue",
}